import React, { useState } from 'react';
import { Button, Card, CardGroup, Container, Modal } from 'react-bootstrap';
import './Project.css'

const Projects = () => {

    return (
        <div>
            <h2 id='projects' className='my-5 text-dark'>Projects</h2>
            <CardGroup className='bg-projects py-5' >
                <Card className='card mx-3 '>
                    <Card.Img className='card ' variant="top" src="https://i.ibb.co/4ttW0kR/Fire-Shot-Capture-003-React-App-raster-auth-web-app.png" />
                    <Card.Body>
                        <Card.Title>Raster Autos</Card.Title>
                        <Card.Text>
                            <h5>Technologies:</h5>
                            <Button variant="secondary" className='p-btn' disabled>React JS</Button>
                            <Button variant="secondary" className='p-btn' disabled>Node JS</Button>
                            <Button variant="secondary" className='p-btn' disabled>MongoDB</Button>
                            <Button variant="secondary" className='p-btn' disabled>Express</Button>
                            <Button variant="secondary" className='p-btn' disabled>CSS</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Bootstrap</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Router</Button>
                            <Button variant="secondary" className='p-btn' disabled>Firebase Authentication</Button>
                            <Button variant="secondary" className='p-btn' disabled>Heroku</Button>
                        </Card.Text>

                        <div className='d-flex justify-content-evenly'>
                            <a href="https://raster-auth.web.app/" target="_blank"><Button className='p-btn' variant='secondary'>Live</Button></a>
                            <a href="https://github.com/programming-hero-web-course-4/niche-website-server-side-Alter80" target="_blank"><Button className='p-btn' variant='secondary'>Git Client Link</Button></a>
                            <a href="https://github.com/programming-hero-web-course-4/niche-website-client-side-Alter80" target="_blank"><Button className='p-btn' variant='secondary'>Git Server Link</Button></a>
                        </div>
                    </Card.Body>

                </Card>
                <Card className='card mx-3 ' >
                    <Card.Img className='card ' variant="top" src="https://i.ibb.co/Gf60Xn5/Fire-Shot-Capture-002-Pizzon-pizzon-assignment11-web-app.png" />
                    <Card.Body>
                        <Card.Title>Pizzon</Card.Title>
                        <Card.Text>
                            <h5>Technologies:</h5>
                            <Button variant="secondary" className='p-btn' disabled>React JS</Button>
                            <Button variant="secondary" className='p-btn' disabled>Node JS</Button>
                            <Button variant="secondary" className='p-btn' disabled>MongoDB</Button>
                            <Button variant="secondary" className='p-btn' disabled>Express</Button>
                            <Button variant="secondary" className='p-btn' disabled>CSS</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Bootstrap</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Router</Button>
                            <Button variant="secondary" className='p-btn' disabled>Firebase Authentication</Button>
                            <Button variant="secondary" className='p-btn' disabled>Heroku</Button>
                        </Card.Text>
                        <div className='d-flex justify-content-evenly'>
                            <a href="https://pizzon-assignment11.web.app/" target="_blank"><Button className='p-btn' variant='secondary'>Live</Button></a>
                            <a href="https://github.com/programming-hero-web-course1/tourism-or-delivery-website-client-side-Alter80" target="_blank"><Button className='p-btn' variant='secondary'>Git Client Link</Button></a>
                            <a href="https://github.com/programming-hero-web-course1/tourism-or-delivery-website-server-side-Alter80" target="_blank"><Button className='p-btn' variant='secondary'>Git Server Link</Button></a>
                        </div>
                    </Card.Body>

                </Card>
                <Card className='card mx-3 ' >
                    <Card.Img className='card' variant="top" src="https://i.ibb.co/YjSFSFZ/Fire-Shot-Capture-001-React-App-alt-medical-web-app.png" />
                    <Card.Body>
                        <Card.Title>Alt-Medic</Card.Title>
                        <Card.Text>
                            <h5>Technologies:</h5>
                            <Button variant="secondary" className='p-btn' disabled>React JS</Button>
                            <Button variant="secondary" className='p-btn' disabled>CSS</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Bootstrap</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Router</Button>
                            <Button variant="secondary" className='p-btn' disabled>HTML</Button>
                            <Button variant="secondary" className='p-btn' disabled>Firebase Authentication</Button>

                        </Card.Text>
                        <div className='d-flex justify-content-evenly'>
                            <a href="https://alt-medical.web.app/" target="_blank"><Button className='p-btn' variant='secondary'>Live</Button></a>
                            <a href="https://github.com/Programming-Hero-Web-Course3/healthcare-related-website-Alter80" target="_blank"><Button className='p-btn' variant='secondary'>Git Link</Button></a>
                        </div>
                    </Card.Body>

                </Card>
                <Card className='card mx-3  '>
                    <Card.Img className='card ' variant="top" src="https://i.imgur.com/OSCJdZj.png" />
                    <Card.Body>
                        <Card.Title>E-ducate</Card.Title>
                        <Card.Text>
                            <h5>Technologies:</h5>
                            <Button variant="secondary" className='p-btn' disabled>HTML</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Router</Button>
                            <Button variant="secondary" className='p-btn' disabled>JavaScript</Button>
                            <Button variant="secondary" className='p-btn' disabled>React JS</Button>
                            <Button variant="secondary" className='p-btn' disabled>CSS</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Bootstrap</Button>
                            <Button variant="secondary" className='p-btn' disabled>React-Router</Button>

                        </Card.Text>
                        <div className='d-flex justify-content-evenly'>
                            <a href="https://e-ducate-hero.netlify.app/" target="_blank"><Button className='p-btn' variant='secondary'>Live</Button></a>
                            <a href="https://github.com/ProgrammingHeroWC4/review-website-Alter80" target="_blank"><Button className='p-btn' variant='secondary'>Git Link</Button></a>
                        </div>
                    </Card.Body>

                </Card>
            </CardGroup>


        </div>
    );
};

export default Projects;